import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UserService } from '../../../core/services/user.service';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-onboarding',
  imports: [RouterLink],
  templateUrl: './onboarding.html',
  styleUrl: './onboarding.scss',
})
export class Onboarding {
  @Input() mobileImage = 'Home.png';
  @Input() desktopImage = 'Home-desktop.png';
  @Input() logoImage = 'logo-vmco-1.svg';
  @Input() desktopStampImage = 'world.png';
  @Input() mobileStampImage = 'world-mobil.png';

  /** Texts */
  @Input() eyebrow = '¡Ey!';
  @Input() title = 'Antes de seguir…';
  @Input() body =
    `Necesitamos tus datos para activar el servicio. Tranqui, los tratamos con toda la seriedad, como debe ser. Consulta nuestra Política de Privacidad en virginmobile.co.`;
  @Input() cta = 'EMPIEZA AHORA';

  @Output() ctaClick = new EventEmitter<void>();

  constructor(
    private userService: UserService,
    private auth: AuthService,
  ) {
    this.userService.setState({
      valid: false,
      user: null,
      puk: null,
      phone: null,
      iccd: null,
    });
  }
}
